module.exports = __webpack_public_path__ + "./docs/img/big-icon-member.aefc781b8b6aa472f34fdb24a888daf2.svg";